import React from 'react';

import Tiff from '../assets/images/introstory/tiff.png';
import Kino from '../assets/images/introstory/kino.png';
import Biff from '../assets/images/introstory/biff.png';
import Filmex from '../assets/images/introstory/filmex.png';
import Glasgow from '../assets/images/introstory/glasgow.png';
import Summary from '../assets/images/introstory/summary.png';
import SummarySp from '../assets/images/introstory/summary-sp.png';

class IntroInner extends React.Component {
    render() {
        return (
            <div className="intro" id="intro">
            <h1>イントロダクション</h1>
            <div className="intro-inner">
                <h2>世界の映画祭を席捲した、圧巻の長編デビュー作</h2>
                <h3>新しい才能に世界が熱狂！</h3>
                <p>監督は短編映画『SIGNATURE』が第70回ロカルノ国際映画祭ほかで高い評価を受け、米アカデミー賞公認映画祭であるエンカウンター短編＆アニメーション映画祭でグランプリを受賞した近浦啓。本作『コンプリシティ／優しい共犯』は北米最大の映画祭、トロント国際映画祭でワールド・プレミア上映され、続いて釜山国際映画祭、ベルリン国際映画祭と世界の名だたる映画祭へ入選し正式出品。そして厳しい目を持つ映画ファンが集まる東京フィルメックスで観客賞を受賞するという、途轍もない長編デビューとなった。</p>
                <h3>中国の実力派俳優ルー・ユーライ × 日本の名優・藤竜也</h3>
                <p>主演は、第55回ベルリン国際映画祭にて銀熊賞受賞の『孔雀－我が家の風景－』でデビューした中国人俳優ルー・ユーライ。常にどこか寂しさを感じさせる瞳と危うげな存在感で、どこにいても自分の存在を確立できない主人公の青年チェン・リャンの哀しみを観客に訴えかける。そしてチェン・リャンの、時に厳しい上司であり時に優しい父のような存在である厳格な蕎麦屋の主人・弘を、日本を代表する名優・藤竜也が見事に演じている。そしてモデルとして世界的に活躍し、本作が映画デビューとなる赤坂沙世が、チェン・リャンが心を寄せる女性・葉月を、チェン・リャンと弘との関係を温かく支える弘の娘カオリを松本紀保が演じ、映画を支えている。</p>
                <div className="intro-images">
                    <div className="intro-images__content">
                        <img src={Tiff} alt="" />
                        <img src={Kino} alt="" />
                    </div>
                    <div className="intro-images__content">
                        <img src={Biff} alt="" />
                        <img src={Filmex} alt="" />
                        <img src={Glasgow} alt="" />
                    </div>
                    <div className="intro-images__content">
                        <img src={Summary} className="pc_only" alt="" />
                        <img src={SummarySp} className="sp_only" alt="" />
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default IntroInner;